import lazy from "../utils/lazy";

export const AuthenticationPage = lazy(() =>
  import(
    /* webpackChunkName: "AuthenticationPage" */ "../modules/Authentication"
  )
);
export const KPIPage = lazy(() =>
  import(/* webpackChunkName: "KPI" */ "../modules/KPI")
);

export const PulseOverviewPage = lazy(() =>
  import(/* webpackChunkName: "PulseOverview" */ "../modules/Pulse/pages/Overview")
);
export const PulseProjectPage = lazy(() =>
  import(
    /* webpackChunkName: "PulseProject" */ "../modules/Pulse/pages/ProjectDetail"
  )
);
export const PulsePortalPage = lazy(() =>
  import(
    /* webpackChunkName: "PulsePortal" */ "../modules/Pulse/pages/PortalDetail"
  )
);
export const PulseReportsPage = lazy(() =>
  import(/* webpackChunkName: "PulseReports" */ "../modules/Pulse/pages/Reports")
);
export const PulseAdminPage = lazy(() =>
  import(/* webpackChunkName: "PulseAdmin" */ "../modules/Pulse/pages/Admin")
);
